import React from "react";

export const Title = React.lazy(() => import("./title/Title"));
export const SearchInput = React.lazy(() => import("./input/SearchInput"));
export const InputTextMaster = React.lazy(() =>
  import("./input/InputTextMaster/InputTextMaster")
);
export const InputTextLabel = React.lazy(() =>
  import("./input/InputTextMaster/InputTextLabel")
);
export const InputFieldMaster = React.lazy(() =>
  import("./input/InputTextMaster/InputFieldMaster")
);
export const InputGroupMaster = React.lazy(() =>
  import("./input/InputGroupMaster/InputGroupMaster")
);
export const InputColonMaster = React.lazy(() =>
  import("./input/InputGroupMaster/InputColonMaster")
);
export const InputOptionMaster = React.lazy(() =>
  import("./input/InputOptionMaster/InputOptionMaster")
);

export const LabelRequired = React.lazy(() =>
  import("./input/InputLabelRequired/LabelRequired")
);

export const InputFieldOption = React.lazy(() =>
  import("./input/InputOptionMaster/InputFieldOption")
);

export const InputFieldAsyncOption = React.lazy(() =>
  import("./input/InputOptionMaster/InputFieldAsyncOption")
);

export const InputAsyncOptionMaster = React.lazy(() =>
  import("./input/InputOptionMaster/InputAsyncOptionMaster")
);

export const InputRadioButton = React.lazy(() =>
  import("./input/InputRadioButton/InputRadioButton")
);

export const InputFileCustom = React.lazy(() =>
  import("./input/InputFileCustom/InputFileCustom")
);

export const InputFileCustomHook = React.lazy(() =>
  import("./input/InputFileCustom/InputFileCustomHook")
);

export const InputFileDropZone = React.lazy(() =>
  import("./input/InputFileDropZone/InputFileDropZone")
);

export const InputTextArea = React.lazy(() =>
  import("./input/InputTextArea/InputTextArea")
);

export const InputReactDatepicker = React.lazy(() =>
  import("./input/InputDatetimeMaster/InputReactDatepicker")
);

export const InputCheckboxMaster = React.lazy(() =>
  import("./input/InputCheckboxMaster/InputCheckboxMaster")
);

export const MasterButton = React.lazy(() => import("./button/MasterButton"));
export const IconButtonDatatable = React.lazy(() =>
  import("./button/IconButtonDatatable")
);

export const Badge = React.lazy(() => import("./badge/Badge"));
export const TabPanel = React.lazy(() => import("./Tab/TabPanel"));

export { default as useTabStyle } from "./Tab/TabStyle";

// Modal
export const Modal = React.lazy(() => import("./Modal/Modal"));
export const ModalDeleteConfirm = React.lazy(() =>
  import("./Modal/ModalDeleteConfirm/ModalDeleteConfirm")
);

export const ModalDefaultError = React.lazy(() =>
  import("./Modal/ModalDefaultError/ModalDefaultError")
);

export const ModalExportList = React.lazy(() =>
  import("./Modal/ModalExportList/ModalExportList")
);

export { default as ModalHistory } from "./Modal/ModalHistory/ModalHistory";

// Datatable
export const TableHeader = React.lazy(() => import("./datatable/TableHeader"));
export const TableToolbar = React.lazy(() =>
  import("./datatable/TableToolbar")
);

export const DatatablesFooterServerSide = React.lazy(() =>
  import("./datatable/DatatablesFooterServerSide")
);
export const DatatablesFooter = React.lazy(() =>
  import("./datatable/TableFooter")
);

// export const DatatablesPagination = React.lazy(() =>
//   import("./datatable/TablePagination")
// );

export { default as DatatablesPagination } from "./datatable/TablePagination";

export const TableCellDefault = React.lazy(() =>
  import("./datatable/TableCellDefault")
);

export const TableAction = React.lazy(() => import("./datatable/TableAction"));
export const TableWrapper = React.lazy(() =>
  import("./datatable/TableWrapper")
);

export { default as CustomSwitch } from "./switch/CustomSwitch";

export { default as LoadImage } from "./images/LoadImage";
export { default as Loading } from "./Loading";
